"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * E-Verify Account Service
 * API for management of E-Verify Accounts
 *
 * The version of the OpenAPI document: 1.0.133
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.IipMatchNoteCategoryToJSON = exports.IipMatchNoteCategoryFromJSONTyped = exports.IipMatchNoteCategoryFromJSON = exports.IipMatchNoteCategory = void 0;
/**
 *
 * @export
 * @enum {string}
 */
var IipMatchNoteCategory;
(function (IipMatchNoteCategory) {
    IipMatchNoteCategory["OUTBOUNDCALL"] = "OUTBOUND_CALL";
    IipMatchNoteCategory["INBOUNDCALL"] = "INBOUND_CALL";
    IipMatchNoteCategory["CCOAGENTRETURNCALL"] = "CCO_AGENT_RETURN_CALL";
    IipMatchNoteCategory["EMAILSENTNOTES"] = "EMAIL_SENT_NOTES";
    IipMatchNoteCategory["MISCELLANEOUSNOTES"] = "MISCELLANEOUS_NOTES";
    IipMatchNoteCategory["RESOLVEDWITHOUTCALLNOTES"] = "RESOLVED_WITHOUT_CALL_NOTES";
    IipMatchNoteCategory["IIPMATCHNOTES"] = "IIP_MATCH_NOTES";
})(IipMatchNoteCategory = exports.IipMatchNoteCategory || (exports.IipMatchNoteCategory = {}));
function IipMatchNoteCategoryFromJSON(json) {
    return IipMatchNoteCategoryFromJSONTyped(json, false);
}
exports.IipMatchNoteCategoryFromJSON = IipMatchNoteCategoryFromJSON;
function IipMatchNoteCategoryFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
exports.IipMatchNoteCategoryFromJSONTyped = IipMatchNoteCategoryFromJSONTyped;
function IipMatchNoteCategoryToJSON(value) {
    return value;
}
exports.IipMatchNoteCategoryToJSON = IipMatchNoteCategoryToJSON;
